package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.KeyData
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.dom.RecordTableView
import com.neurobs.js.util.StringUtilities.dateString

import scala.concurrent.{Future, Promise}

class KeyListController extends AdminListAdapter[KeyData] {

	override def title = "Keys"

	override def itemName = "Key"

	override def columnHeaders = Seq(
		"DID",
		"Created",
		"Identifier",
		"Description",
		"Type"
	)

	override def itemRow(a: KeyData, delegate: Option[AdminPanelDelegate], controller: AdminListController[KeyData]): Seq[RecordTableView.CellContent] = Seq(
		a.id.toString,
		dateString(a.createdAt),
		a.identifier.getOrElse(""): String,
		a.description.getOrElse(""): String,
		a.storageType.toString
	)

	override val create: Option[AdminListController[KeyData] => Unit] = None

	override def get(): Future[Either[String, Seq[KeyData]]] = {
		val promise = Promise[Either[String, Seq[KeyData]]]
		CCABServer.getKeys {
			case Left(error) => promise.success(Left(error.message))
			case Right(data) => promise.success(Right(data.sortBy(_.id)))
		}
		promise.future
	}
}

object KeyListController {
	def apply(): AdminListController[KeyData] = new AdminListController[KeyData](new KeyListController)
}